import TreatmentPlanService, {
  type TArchiveTreatmentPlanParams,
} from "@/api/models/treatmentPlan/treatmentPlan";
import { useGenericMutation } from "@/composables/shared/mutations/useGenericMutation";
import { TreatmentPlanQueryKeys } from "@/composables/models/treatmentPlan/useTreatmentPlan";
import { CotreatmentDashboardQueryKeys } from "@/composables/models/treatmentPlan/useCotreatmentDashboard";
import { ReferralDashboardQueryKeys } from "@/composables/models/treatmentPlan/useReferralDashboard";
import { PatientDashboardQueryKeys } from "@/composables/models/patient/usePatientDashboard";

/** Separate from `useTreatmentPlan.ts` because both dashboards import that file: taking their query keys into it would close an import cycle. */
export const useArchiveTreatmentPlan = () =>
  useGenericMutation<void, TArchiveTreatmentPlanParams>({
    mutationFn: ({ treatmentPlanId, jobId }) =>
      TreatmentPlanService.archive({ treatmentPlanId }, {}, { job_id: jobId }),
    feature: "treatmentPlan.archive",
    params: { neededKey: ["treatmentPlanId", "jobId"] },
    invalidates: ({ treatmentPlanId }) => [
      TreatmentPlanQueryKeys.detail(treatmentPlanId),
      TreatmentPlanQueryKeys.actionableCounts(),
      PatientDashboardQueryKeys.dashboard(),
      CotreatmentDashboardQueryKeys.dashboard(),
      ReferralDashboardQueryKeys.dashboard(),
    ],
  });
